function normalizeQuery(query = '') {
  return String(query || '')
    .trim()
    .toLowerCase();
}

export function isPaidDineInRecord(record = {}) {
  return record?.status === 'Paid' && record?.serviceType === 'dine-in';
}

export function filterRecordsByDateRange(records = [], from, to) {
  if (!from || !to) return records;

  const fromTs = toUnixSeconds(from);
  const toTs = toUnixSeconds(to);
  if (!fromTs || !toTs) return records;

  return records.filter((record) => {
    const paidAt = toUnixSeconds(record?.paidAt);
    return paidAt >= fromTs && paidAt <= toTs;
  });
}

function toUnixSeconds(value) {
  const normalized = Number(value);
  if (!Number.isFinite(normalized) || normalized <= 0) return 0;
  return normalized > 9999999999 ? Math.floor(normalized / 1000) : Math.floor(normalized);
}

export function filterRecordsByPoints(records = [], pointIds = []) {
  if (!Array.isArray(pointIds) || pointIds.length === 0) return records;
  return records.filter((record) => pointIds.includes(record?.pointId));
}

export function filterRecordsByEmployeeSearch(records = [], query = '') {
  const normalizedQuery = normalizeQuery(query);
  if (!normalizedQuery) return records;

  return records.filter((record) => {
    const haystack = [record?.employeeName].filter(Boolean).join(' ').toLowerCase();
    return haystack.includes(normalizedQuery);
  });
}

export function filterChecksByQuery(checks = [], query = '') {
  const normalizedQuery = normalizeQuery(query);
  if (!normalizedQuery) return checks;

  return checks.filter((check) => {
    const haystack = [check?.checkNumber, check?.tableNumber, check?.netAmount, check?.paidAt, check?.guestRating]
      .filter((value) => value !== null && value !== undefined && String(value).length)
      .join(' ')
      .toLowerCase();

    return haystack.includes(normalizedQuery);
  });
}
